import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdDelete, MdEdit } from "react-icons/md";
import { getUsefulLinkDetailsapi } from "Services/allApi";
import { editUsefulLinkPage } from "Services/allApi";
import { deleteUsefulLinkApi } from "Services/allApi";
import { addUsefulLinkApi } from "Services/allApi";

const UsefulLink = () => {
    const [usefulLinks, setUsefulLinks] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedLink, setSelectedLink] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState("");
    const [link, setLink] = useState("");
    const [displayValue, setDisplayValue] = useState(true);  // Changed to boolean

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
        setIsModalOpen(false);
        setContent("");
        setLink("");
        setDisplayValue(true);  // Reset to true
    };

    const handleSave = async () => {
        if (!content.trim() || !link.trim()) {
            toast.error("Content and Link are required!");
            return;
        }

        const newLinkData = { content, link, display: displayValue };

        try {
            const response = await addUsefulLinkApi(newLinkData);
            if (response?.status === 200) {
                toast.success("Useful link added successfully!");
                closeModal();
                fetchUsefulLinks(); // Refresh the table in the parent component
            } else {
                toast.error("Failed to add useful link.");
            }
        } catch (error) {
            console.error("Error adding useful link:", error.message);
        }
    };

    const [editContent, setEditContent] = useState("");
    const [editLink, setEditLink] = useState("");
    const [editDisplay, setEditDisplay] = useState(true); // Changed to boolean

    useEffect(() => {
        fetchUsefulLinks();
    }, []);

    const fetchUsefulLinks = async () => {
        try {
            setLoading(true);
            const response = await getUsefulLinkDetailsapi();
            if (response?.status === 200 && response.data) {
                setUsefulLinks(response.data);
            } else {
                console.error("Unexpected API Response:", response);
                toast.error('Failed to fetch data');
                setUsefulLinks([]);
            }
        } catch (error) {
            console.error("Error fetching useful links:", error.message);
            toast.error('Error fetching data');
            setUsefulLinks([]);
        } finally {
            setLoading(false);
        }
    };

    const openEditModal = (link) => {
        setSelectedLink(link);
        setEditContent(link.content || "");
        setEditLink(link.link || "");
        setEditDisplay(link.display === true); // Direct comparison with boolean `true`
        setIsEditModalOpen(true);
    };
    

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedLink(null);
    };

    const handleEditSave = async () => {
        if (!selectedLink) return;

        const updatedData = {
            content: editContent,
            link: editLink,
            display: editDisplay // Save as boolean
        };

        try {
            const response = await editUsefulLinkPage(selectedLink.id, updatedData);
            if (response?.status === 200) {
                toast.success("Useful link updated successfully!");
                closeEditModal();
                fetchUsefulLinks(); // Refresh data
            } else {
                toast.error("Failed to update useful link.");
            }
        } catch (error) {
            console.error("Error updating useful link:", error.message);
            toast.error("Error updating data.");
        }
    };

    const handleDeleteLink = async (id) => {
        try {
            const response = await deleteUsefulLinkApi(id);
            if (response?.status === 204) {
                toast.success("Useful link deleted successfully!");
                fetchUsefulLinks(); // Refresh data
            } else {
                toast.error("Failed to delete useful link.");
            }
        } catch (error) {
            console.error("Error deleting useful link:", error.message);
            toast.error("Error deleting data.");
        }
    };



    return (
        <>
            <h2 className="mt-5 text-xl font-bold text-center mb-4 dark:text-white">Useful Links</h2>

            {loading ? (
                <div className="text-center py-4 text-purple-500">Loading...</div>
            ) : (
                <>
                    <>
                        <button
                            className="rounded-lg px-7 py-2 text-white bg-green-700 font-large text-large transition duration-200 hover:bg-green-800 float-end"
                            onClick={openModal}
                        >
                            Add +
                        </button>

                        {/* Add Modal */}
                        {isModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
                                <div className="bg-white p-6 rounded-lg w-[600px]  dark:!bg-navy-700 dark:text-white">
                                    <h2 className="text-lg font-bold mb-4">Add Useful Link</h2>
                                    <input
                                        type="text"
                                        className="w-full border p-2 mb-2 dark:!bg-navy-700 dark:text-white"
                                        placeholder='Content'
                                        value={content}
                                        onChange={(e) => setContent(e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        className="w-full border p-2 mb-2 dark:!bg-navy-700 dark:text-white"
                                        placeholder='Link'
                                        value={link}
                                        onChange={(e) => setLink(e.target.value)}
                                    />

                                    {/* Toggle for True/False */}
                                   

                                    <label className="inline-flex items-center cursor-pointer mt-3">
                            <span className="me-5">Display</span>
                            <input
                                type="checkbox"
                                checked={displayValue}
                                
                                onChange={(e) => setDisplayValue(e.target.checked)}
                                className="sr-only peer"
                            />
                            <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-purple-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:bg-white"></div>
                        </label>

                                    <div className="flex justify-end space-x-2">
                                        <button className="px-4 py-2 bg-gray-300 rounded-lg" onClick={closeModal}>Cancel</button>
                                        <button className="px-4 py-2 bg-blue-500 text-white rounded-lg" onClick={handleSave}>Save</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                        <br /> <br />
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full dark:text-white">
                            <thead>
                                <tr className="bg-gray-100 text-left  dark:!bg-navy-700 dark:text-white">
                                    <th className="px-4 py-2">Content</th>
                                    <th className="px-4 py-2">Link</th>
                                    <th className="px-4 py-2">Display</th>
                                    <th className="px-4 py-2 text-center">Edit</th>
                                    <th className="px-4 py-2 text-center">Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {usefulLinks?.length > 0 ? (
                                    usefulLinks.map((link) => (
                                        <tr key={link.id} className="hover:bg-gray-50 hover:dark:bg-navy-800">
                                            <td className="px-4 py-2">{link.content || "N/A"}</td>
                                            <td className="px-4 py-2">
                                                <a href={link.link || "#"} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
                                                    {link.link || "N/A"}
                                                </a>
                                            </td>
                                            <td className="px-4 py-2">
                                                <span
                                                    className={`px-4 py-2 ${link.display ? 'true' : 'false'} text-black rounded-full`}

                                                >
                                                    {link.display ? 'true' : 'false'}
                                                </span>
                                            </td>
                                            <td className="px-4 py-2 text-center">
                                                <button
                                                    className="rounded-lg px-4 py-2 text-green-700 transition duration-200 hover:bg-white-700"
                                                    onClick={() => openEditModal(link)}
                                                >
                                                    <MdEdit className='text-green-700 text-2xl' />
                                                </button>
                                                
                                            </td>
                                            <td className="px-4 py-2 text-center">
                                            <button className="ml-4" onClick={() => handleDeleteLink(link.id)}>
                                                    <MdDelete className='text-red-700 text-2xl' />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="px-4 py-2 text-center text-red-500">
                                            No useful links found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {/* Edit Modal */}
            {isEditModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg w-[600px] dark:!bg-navy-700 dark:text-white">
                        <h2 className="text-lg font-bold mb-4">Edit Useful Link</h2>
                        <input
                            type="text"
                            className="w-full border p-2 mb-2 dark:!bg-navy-700 dark:text-white"
                            value={editContent}
                            onChange={(e) => setEditContent(e.target.value)}
                        />
                        <input
                            type="text"
                            className="w-full border p-2 mb-2 dark:!bg-navy-700 dark:text-white"
                            value={editLink}
                            onChange={(e) => setEditLink(e.target.value)}
                        />
                        {/* Toggle for display */}

                        <label className="inline-flex items-center cursor-pointer mt-3">
                        <span className="me-5">Display</span>
                            <input
                                type="checkbox"
                                checked={editDisplay}
                                
                                onChange={(e) => setEditDisplay(e.target.checked)}
                                className="sr-only peer"
                            />
                            <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-purple-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:bg-white"></div>
                        </label>

                        <div className="flex justify-end space-x-2">
                            <button className="px-4 py-2 bg-gray-300 rounded-lg" onClick={closeEditModal}>Cancel</button>
                            <button className="px-4 py-2 bg-blue-500 text-white rounded-lg" onClick={handleEditSave}>Save</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Toast Notifications */}
            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
        </>
    );
};

export default UsefulLink;
